<template>
  <span></span>
</template>

<script>
import { performanceRemind,sendPerformanceRemind,personnelLookPerformance } from '/src/api/performance/performance'
export default {
  name: "Remind",
  methods:{
    sendPerformanceRemind(type){
      console.log(type)
      sendPerformanceRemind(type).then(val=>{
        if (val.status == 200){
          this.$notify.success({title: '提示', message: '推送成功！', offset: 40})
        }else {
          this.$notify.error({title: '提示', message: '推送失败！', offset: 40})
        }
      })
    }
  },
  created() {
    performanceRemind().then(val=>{
      if (val.status == 200){
        for (const item of val.data) {
          setTimeout(() => {
            this.$notify({
              type: 'warning',
              title: item.title,
              duration:item.duration,
              dangerouslyUseHTMLString: true,
              offset: 40,
              message:
                  '<div style="width: 260px;">' +
                  '<div>'+item.content+'</div>'+
                  '<button class="el-button el-button--danger el-button--small"' +
                  ' style="float: right;margin: 12px 0 6px 0" id="notify-btn" data-type="'+item.type+'">提醒提交</button>' +
                  '</div>'
            });
            const btn = document.getElementById('notify-btn');
            if (btn) {
              btn.addEventListener('click', (event) => {
                this.sendPerformanceRemind(event.currentTarget.dataset.type);
              });
            }
          }, 1000);
        }
      }
    })
  }
}
</script>

<style scoped>
.el-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>